<app-modal>
  <form (ngSubmit)="onSubmit()"
        [formGroup]="formGroup">

    <h2 class="mb-0025">Reassign follow-up flag for:</h2>
    <h3 class="mb-0100"> {{data.entityName}}</h3>

    <mat-form-field class="col__">
      <mat-label>Assign to user</mat-label>
      <input type="text"
             placeholder="Search users"
             matInput
             [formControl]="userSearchControl"
             [matAutocomplete]="auto">
      <mat-autocomplete autoActiveFirstOption
                        #auto="matAutocomplete"
                        [displayWith]="userDisplayFn">
        <mat-option *ngFor="let option of filteredResults$ | async"
                    [value]="option">
          {{ option.firstName }} {{option.lastName}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <button class="btn"
            type="submit"
            [disabled]="!hasChanges || formGroup.invalid || isSaving">
      Save Changes
    </button>
  </form>
</app-modal>
